"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _assert = _interopRequireDefault(require("assert"));
var _updateLiveChatState = _interopRequireDefault(require("./utils/updateLiveChatState"));
var _analytics = _interopRequireDefault(require("../analytics"));
var _constants = require("./constants");
var _checkAbcSupport = _interopRequireDefault(require("../apple-business-chat-scripts/check-abc-support"));
var _snippet = _interopRequireDefault(require("../snippet"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  EVENT,
  publish
} = _analytics.default;
let timer;
let currentEngagementId;
const changePreviousPathName = previousPathName => dispatch => dispatch({
  previousPathName,
  type: _constants.PREVIOUS_PATH_NAME_CHANGE
});
const clearTimer = () => {
  if (!timer) return;
  currentEngagementId = null;
  clearInterval(timer);
  timer = null;
};
const pollEngagement = (engagementId, windowObject, dispatch) => {
  if (engagementId === currentEngagementId) {
    return;
  }
  clearTimer();
  currentEngagementId = engagementId;
  let currentStatus;
  const worker = () => {
    const engagementState = _lodash.default.invoke(windowObject, 'lpTag.taglets.rendererStub.getEngagementInfo', engagementId);
    const status = _lodash.default.get(engagementState, 'state', 0);
    if (currentStatus !== status) {
      dispatch({
        status,
        type: _constants.LIVECHAT_STATUS
      });
      currentStatus = status;
    }
  };
  timer = setInterval(worker, 500);
  worker();
};
const setIsAbcSupported = (isAbcSupported, dispatch) => {
  if (isAbcSupported) {
    publish(EVENT.MARKETING_INFO, {
      targetChannel: 'messaging'
    });
  }
  dispatch({
    payload: isAbcSupported,
    type: _constants.LIVECHAT_ABC_SUPPORTED
  });
};
const load = function (_ref) {
  let {
    accountId,
    engagementId,
    sections
  } = _ref;
  let windowObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  let onChatStateChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _lodash.default.noop;
  let submitChatStateToGA4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _lodash.default.noop;
  return dispatch => {
    (0, _assert.default)(accountId);
    (0, _assert.default)(engagementId);
    (0, _assert.default)(sections);
    (0, _snippet.default)({
      accountId,
      sections
    });
    const isAbcSupported = (0, _checkAbcSupport.default)();
    setIsAbcSupported(isAbcSupported, dispatch);
    dispatch({
      type: _constants.LIVECHAT_POLLING_START
    });
    _lodash.default.invoke(windowObject, 'lpTag.events.bind', 'lpUnifiedWindow', 'conversationInfo', data => {
      dispatch({
        data,
        type: _constants.LIVECHAT_CONVERSATION_INFO
      });
      onChatStateChange(data);
      (0, _updateLiveChatState.default)(data, submitChatStateToGA4);
    });
    pollEngagement(engagementId, windowObject, dispatch);
  };
};
const updateEngagementId = function (_ref2) {
  let {
    engagementId
  } = _ref2;
  let windowObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  return dispatch => {
    pollEngagement(engagementId, windowObject, dispatch);
  };
};
const unload = () => dispatch => {
  if (!timer) return;
  dispatch({
    type: _constants.LIVECHAT_POLLING_STOP
  });
  clearTimer();
};
const launch = function (_ref3) {
  let {
    engagementId
  } = _ref3;
  let windowObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  return dispatch => {
    dispatch({
      type: _constants.LIVECHAT_LAUNCH
    });
    _lodash.default.invoke(windowObject, 'lpTag.taglets.rendererStub.click', engagementId);
  };
};
const setNewPageTag = function () {
  let windowObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return dispatch => {
    dispatch({
      type: _constants.LIVECHAT_REFRESH
    });
    _lodash.default.invoke(windowObject, 'lpTag.newPage', windowObject.location.href);
  };
};
var _default = {
  changePreviousPathName,
  clearTimer,
  launch,
  load,
  setNewPageTag,
  unload,
  updateEngagementId
};
exports.default = _default;